var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5144 20.1329V18.8438C35.5144 18.1313 34.9378 17.5548 34.2253 17.5548H32.1809L29.9805 15.3543C29.7387 15.1126 29.4114 14.9766 29.069 14.9766H27.7799V12.3985H29.069C29.7815 12.3985 30.3581 11.8219 30.3581 11.1094C30.3581 10.3969 29.7815 9.82031 29.069 9.82031C26.2517 9.82031 18.9597 9.82031 16.1783 9.82031C15.4657 9.82031 14.8892 10.3969 14.8892 11.1094C14.8892 11.8219 15.4657 12.3985 16.1783 12.3985H17.4673V14.9766H16.1783C15.8359 14.9766 15.5085 15.1126 15.2669 15.3543L12.6887 17.9325C12.447 18.1741 12.311 18.5015 12.311 18.8438V31.7346C12.311 32.077 12.447 32.4043 12.6887 32.646L17.845 37.8023C18.0867 38.044 18.414 38.18 18.7564 38.18H31.6472C32.1356 38.18 32.5812 37.9043 32.8003 37.4675L35.3784 32.3112C35.4678 32.1324 35.5144 31.9347 35.5144 31.7346H38.2644V20.1329H35.5144Z",
    fill: "#0061ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4444 17.5547C7.73189 17.5547 7.15533 18.1312 7.15533 18.8438V24.0001H4.57717V18.8438C4.57717 18.1312 4.00061 17.5547 3.2881 17.5547C2.57558 17.5547 1.99902 18.1312 1.99902 18.8438V31.7345C1.99902 32.447 2.57558 33.0236 3.2881 33.0236C4.00061 33.0236 4.57717 32.447 4.57717 31.7345V26.5782H7.15533V31.7345C7.15533 32.447 7.73189 33.0236 8.4444 33.0236H9.73348V17.5547H8.4444Z",
    fill: "#0061ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4214 17.5547H42.1323C41.4204 17.5547 40.8433 18.1318 40.8433 18.8438V34.3127C40.8433 35.0246 41.4204 35.6017 42.1323 35.6017H43.4214C44.8453 35.6017 45.9996 34.4475 45.9996 33.0236V20.1328C45.9996 18.7089 44.8453 17.5547 43.4214 17.5547Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAny);
export default ForwardRef;